import { Plugins } from '@leverege/plugin';
import ComparatorPlugins from './comparator/PluginSetup.js';
import AttributeCondition from './AttributeCondition.js';
import AttributeConditionEditor from "./AttributeConditionEditor.js";
import AttributeEvaluator from './AttributeEvaluator.js';
export default {
  install() {
    ComparatorPlugins.install();
    Plugins.add('Model', {
      type: AttributeCondition.TYPE,
      model: AttributeCondition
    });
    Plugins.add('ModelEditor', {
      type: AttributeCondition.TYPE,
      editor: AttributeConditionEditor
    });
    Plugins.add('Condition', AttributeCondition);
    Plugins.add('ConditionEvaluator', {
      type: AttributeCondition.TYPE,
      evaluator: AttributeEvaluator
    });
  }
};